<template>
  <div class="insurance-query-box">
    <div class="insurance-query-content">
      <div class="insurance-query-title">
        <img src="@/assets/img/company-appointment/banner.png">
      </div>
      <div class="form-box">
        <div class="img_title">
          <img src="@/assets/img/company-appointment/title.png" />
           <!-- <span>参保人信息</span> -->
        </div>
        <van-form :show-error="false" ref="buyInfoForm" :validate-first="false" @submit="submit">
          <!-- <div class="tips-info">姓名</div> -->
          <div class="tips-info">姓名</div>
          <van-field class="input-ele" v-model="insuredPersonName" name="insuredPersonName" placeholder="请输入被保险人姓名" :rules="formRules.insuredPersonName" clearable />
          <div class="tips-info">证件号码</div>
          <van-field class="input-ele" v-model="insuredPersonIdNo" name="insuredPersonIdNo" placeholder="请输入身份证号" :rules="formRules.insuredPersonIdNo" clearable />
          <!-- <van-field 
            label="姓名" 
            v-model="insuredPersonName" 
            input-align="right"
            name="insuredPersonName" 
            placeholder="请输入被保险人姓名" 
            :rules="formRules.insuredPersonName" 
            clearable 
          /> -->
          <van-field
          style="display:none;"
            class="appntIdTypeName"
            label="证件类型"
            name="appntIdTypeName"
            v-model="documenttype"
            placeholder="请选择证件类型"
            :rules="formRules.insuredPersonIdType"
            :is-link="true"
            input-align="right"
            clearable
            readonly
            @click="showTypeFlag = true"
          />
          <!-- <van-field
            border
            input-align="right"
            label="证件号码" 
            v-model.trim="insuredPersonIdNo" 
            name="insuredPersonIdNo" 
            placeholder="请输入被保险人证件号码" 
            :rules="formRules.insuredPersonIdNo" 
          /> -->
          <van-field v-show="false" />
        </van-form>
      </div>
      <div>  
        <van-button class="submit-btn" round block type="submit"  id="Insured_Inquiry_Query" @click="butck" >
          立即查询
        </van-button>
      </div>
    </div>
    <!-- 证件类型弹出框 -->
    <van-popup v-model="showTypeFlag" round position="bottom">
      <van-picker
        title="证件类型"
        show-toolbar
        :columns="cardTypeColumns"
        @cancel="showTypeFlag = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- <force-bind /> -->
    <!-- <div class="share_good"></div> -->
  </div>
</template>

<script>
import { CHECK_NAME, CHECK_ID, CHECK_PASSPORT_CARD, CHECK_BACK_CARD } from '../../util/validate'
import { HalfFullWidithCharactor, EnNameValidate } from '@/util/insu-validate.js'

import { FindUserPersonInsuranceDetail } from '../../api/user'
import { AppCode } from '../../util/auth'

// import {isnodedatalist }from './../../util/requires.js'
// import { Dialog } from 'vant'

export default {
  name: 'InsuranceQuery',
  components: {},
  mixins: [],
  props: {},

  data() {
    return {
      policyList: [], // 保单列表
      documenttype: '身份证', // 证件类型
      insuredPersonIdType: 'identityCard', // 证件类型
      insuredPersonName: '', // 姓名
      insuredPersonIdNo: '',  // 证件号码
      showTypeFlag: false,
      befortest:/^[1-9]\d{7}(?:0\d|10|11|12)(?:0[1-9]|[1-2][\d]|30|31)\d{3}$/,
      // 证件类型集合
      cardTypeColumns: [
        { type: 'identityCard', text: '身份证' },
        { type: 'HongKongMacaoAndTaiwanPass', text: '港澳台同胞证' },
        { type: 'officerCard', text: '军官证' },
        { type: 'passport', text: '护照' }
      ],
      formRules: {
        insuredPersonName: [
          { required: true, message: '请填写被保险人姓名' }
          // {
          //   validator: this.enNameValidator,
          //   message: '请输入2-60全大写字母名字'
          // }
        ],
        insuredPersonIdType: [{ required: true, message: '证件类型' }],
        insuredPersonIdNo: [
          { required: true, message: '请填写证件号码' }
          // {
          //   validator: this.IdNoValidator,
          //   message: '证件号格式不正确'
          // }
        ]
      }
    }
  },

  computed: {},

  watch: {},

  created() {
    // if (this.payType === 'alipayAcc') { // 支付方式为支付宝时做埋点
    //   // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-undef
   
    // }
  },

  mounted() {

    },

  destroyed() {},

  filters: {},

  methods: {
    onConfirm(values) {
      // console.log(values)
      this.insuredPersonIdType = values.type
      this.documenttype = values.text
      this.showTypeFlag = false;
      // 姓名
      console.log(this.$refs.buyInfoForm)
      this.$refs.buyInfoForm.resetValidation()
      this.$refs.buyInfoForm.validate().catch(() => {})
      // 证件号
      // this.$refs.buyInfoForm.resetValidation('insuredPersonIdNo')
      // this.$refs.buyInfoForm.validate('insuredPersonIdNo').catch(() => {})
    },
    // 校验姓名规则为中文
    cnNameValidator(val) {
      return CHECK_NAME(val)
    },
    // 校验英文
    enNameValidator(val) {
      if (this.insuredPersonIdType === 'passport') {
        this.formRules.insuredPersonName[1].message = '请输入2-60全大写字母名字'
        return EnNameValidate(HalfFullWidithCharactor.ToCDB(val))
      } else {
        this.formRules.insuredPersonName[1].message = '姓名由中文构成，2-20个汉字'
        return CHECK_NAME(val)
      }
    },
    /**
     * @desc 校验身份证号格式是否正确
     * @return {boolean}
     */
    IdNoValidator(val) {
      switch (this.insuredPersonIdType) {
        case 'identityCard':
          return CHECK_ID(val)
        case 'passport':
          return CHECK_PASSPORT_CARD(val)
        default:
          return CHECK_BACK_CARD(val.replace(/\(+?|\(+?.*?\)+?|\)/g, ''))
      }
    },
    async submit() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...'
      })
      try {
        const obj = {
          insuredPersonName: this.insuredPersonName, 
          insuredPersonIdNo: this.insuredPersonIdNo,
          insuredPersonIdType: this.insuredPersonIdType,// 证件类型
          insuranceProductCode: process.env.VUE_APP_BAOSICODE, // 产品编码
          payStatus: 'payYet', // 支付状态-已支付
          appCodeId: AppCode
        }
        
         FindUserPersonInsuranceDetail(obj).then((data)=>{
            // eslint-disable-next-line no-undef
            __bl.api({api:"成功查询投保信息",success:true,c1:"taSR_YL", time:0})
            // eslint-disable-next-line no-undef time:接口的耗时
            // eslint-disable-next-line no-undef
            // console.log('埋点测试', __bl.api({api:"成功查询投保信息",success:true,c1:"taSR_YL", time:0}))
           console.log("data",data)
            if(data===undefined){
               this.$dialog.alert({
                message: '未找到您的参保信息\n请确认输入的内容是否正确',
                width: '80%'
              })
            }else{
           sessionStorage.setItem('policyList', JSON.stringify(data))
            this.$router.push({
              path: '/insured-policy-detail'
            })
            }
         })
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
      toast.clear()
    },
    butck(){
       this.$refs.buyInfoForm.submit()
  }
  }
}
</script>

<style scoped lang="scss">
.img_title{
  width: pxrem(312);
  margin: 0 auto;
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
  span{
    font-size: pxrem(40);
    font-weight: bold;
    color: #FFFFFF;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    right: 0;
    bottom: 4px;
    top: 0;
  }
  img{
    width: pxrem(312);
  }
}
.share_good{
  width: px2rem(319);
  height: px2rem(159);
  background: url('../../assets/img/company-appointment/fx.png') no-repeat;
  background-size: 100%;
  position: fixed;
  top: 60%;
  right: 0;
}
.insurance-query-box {
  min-height: 100vh;
}

.insurance-query-content {
  min-height: 100vh;
  // background:  url('../../assets/img/company-appointment/cloud.png') top/100% auto no-repeat #F5F4F7;
  // padding: 0 px2vw(72) px2vw(30);
}

.insurance-query-title {
  img{
    width: 100%;
  }
}
.form-box {
  width: 90%;
  margin: 0 auto;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 40px 0 50px 15px;
  position: relative;
  top: xvw(-60);
  & .van-field {
    border: none;

    & /deep/.van-field__control {
      color: #000;
      outline: none;
       &::-webkit-input-placeholder {
         color: #D8D8D8 !important;
      }
    }
  }
}

.submit-btn {
  width: 85%;
  background: linear-gradient(180deg, #FE8066 0%, #D10003 100%);
  border: none;
  outline: none;
  font-size: px2rem(50);
  color: #fff;
  margin: xvw(46) auto;
  height: px2rem(50,375);
  // letter-spacing: px2rem(20);
}
/deep/.van-cell::after{
  left: 0px;
  border-bottom-color:#CCC;
}
/deep/.van-cell{
  height: px2rem(150);
  line-height: px2rem(88);
  padding-left: 0px;
  overflow: initial;
}
/deep/.van-cell__right-icon{
  margin-top: 5px;
  color: #D8D8D8;
  transform: rotate(90deg);
}
/deep/.van-field__label{
  color: #000;
}
/deep/.van-cell__value{
  line-height: normal;
  padding-right:24px;
}
/deep/.appntIdTypeName .van-cell__value{
  line-height: inherit;
  padding-right:0px;
}

/deep/.van-dialog{
  width:355px!important;
  padding: 24px !important;
}
/deep/.van-dialog__header--isolated{
  padding: 20px !important;
}
/deep/.van-dialog__message{
  text-align: left;
}

.tips-info {
  font-size: px2rem(16, 375);
  padding-top: px2vw(60);
  margin-bottom: px2vw(20);
  color: #333;
}
.input-ele {
  font-size: px2rem(16, 375);
  padding-top: 2px;
}
</style>

